const Cookie = require("js-cookie");
const VueI18n = require("vue-i18n");
import zh from "@/locales/zh.json";
import en from "@/locales/en.json";

const i18n = new VueI18n({
  // 语言标识：cookie 未设置时显式回退 en_US（否则 i18n.te() 永远 false，menu.* 覆盖失效）
  locale: Cookie.get("lang") || "en_US",
  fallbackLocale: "en_US", // 默认语言
  messages: {
    zh_CN: zh, // 中文语言包
    en_US: en // 英文语言包
  }
});

export default i18n;
